export default "__VITE_ASSET__BKhsnhDC__"